import React, { useState, useEffect } from 'react'
import { useTranslation } from "react-i18next";
import "../../src/styles/global.css";
import { Button, Alert, Row, Col, Image, Modal } from "react-bootstrap";
import { Navigate, Link, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from 'react-router-dom';
import Header from '../Components/PageComponent/Layout/Header';
import Footer from '../Components/PageComponent/Layout/Footer';
import { BsAwardFill, BsFillEaselFill, BsFillJournalBookmarkFill, BsPersonStanding, } from "react-icons/bs";
import { FaLocationDot } from "react-icons/fa6";
import { MdMarkEmailUnread } from "react-icons/md";
import { FaPhoneAlt } from "react-icons/fa";
import { AiFillHeart, AiFillTags } from "react-icons/ai";
import SupplierProductCards from '../Components/PageComponent/Supplier/SupplierProductCards';
import { fetchSupplierProductList, getSupplierDetails } from '../redux/actions/ProjectReportAction';
import profilePic from "../assets/images/users/user-1.jpg";
import CmLeadModal from '../Components/PageComponent/GetEnquiry';
import { decodeBase64ToId } from '../util/generalUtills';


export default function Supplier() {
    const { t } = useTranslation();
    const router = useNavigate();
    const dispatch = useDispatch();
    let { id } = useParams();
    const { supplierDetail, errors, loadingSupplier ,supplierProductDetail} = useSelector((state) => state.projectReportReducer);
    const { AuthReducer: { auth } } = useSelector((state) => state);
    const [supplierID, setSupplierID] = useState(null);
    const [is404, setIs404] = useState(false);

    useEffect(() => {
        if (id) {
            setSupplierID(decodeBase64ToId(id));
        }
    }, [id]);
    useEffect(() => {
        if (errors?.errors?.status == true) {
            setIs404(true);
        }
    }, [errors]);

    useEffect(() => {
        if (supplierID) {
            dispatch(getSupplierDetails(supplierID));
        }
    }, [supplierID]);


    const [page, setPage] = useState(1);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const handleClose = () => setModalShow(false);
    useEffect(() => {
        dispatch(fetchSupplierProductList(supplierID));
    }, [supplierID])

    return (

        is404 ? (
            <div className="error-404 text-center py-5" >
                <div className="container">
                    <h1 className="display-1 text-danger">404</h1>
                    <h3 className="mb-3">Oops! Supplier Not Found</h3>
                    <p className="text-muted mb-4">
                        The supplier you are looking for might have been removed, had their name changed, or is temporarily unavailable.
                    </p>
                    <Link to="/" className="btn btn-primary">
                        Go Back to Homepage
                    </Link>
                    <div className="mt-2">
                        <img src="https://i.imgur.com/qIufhof.png" alt="Not Found" className="img-fluid" style={{ maxWidth: '400px' }} />
                    </div>
                </div>
            </div>
        ) : (
            <>
                <Header />
                <main className="block-main bg-white">
                    {loadingSupplier ? <div className="loader text-center h-100"></div> :
                        (<>
                            <div className="bg-gray ">
                                <div className="container">
                                    <div className="hero-block-two">
                                        <div className="hero-block-two-img text-center">
                                            <Image
                                                src={
                                                    supplierDetail.enterprise_logo
                                                        ? `https://msmesupplier.s3.ap-south-1.amazonaws.com/${supplierDetail?.enterprise_logo}`
                                                        : profilePic
                                                }
                                                width={150}
                                                objectFit="cover"
                                                layout="fill"
                                            />

                                        </div>
                                        <div className="hero-block-two-body">
                                            <div className="hero-block-two-body-top">
                                                <div className="hero-block-two-body-left">
                                                    <p className="c-badge bg-white text-primary mb-2 ">
                                                        {supplierDetail?.type}
                                                    </p>
                                                    <h4>
                                                        {supplierDetail?.business_name} ({supplierDetail?.name})
                                                    </h4>
                                                    <span className='text-secondary'> <strong>Sectors:</strong> {supplierDetail?.sectors?.map((ind) => ind?.sector?.name).join(' , ')}</span><br />
                                                    <span className='text-secondary'> <strong>Deals In:</strong> {supplierDetail?.industries?.map((ind) => ind?.industry?.name).join(' , ')}</span>
                                                    <div className="hero-block-two-body-bottom mt-2">
                                                        <div className='row'>
                                                            <div className='col-6 d-flex align-items-center gap-2'>
                                                                <div className="icon-circle bg-white">
                                                                    <MdMarkEmailUnread className="text-secondary" />
                                                                </div>
                                                                <p className="mb-0 f-small">{supplierDetail?.email}</p>
                                                            </div>
                                                            <div className='col-6 d-flex align-items-center gap-2'>
                                                                <div className="icon-circle bg-white">
                                                                    <FaPhoneAlt className="text-secondary" />
                                                                </div>
                                                                <p className="mb-0 text-secondary f-small">{supplierDetail?.mobile}</p>
                                                            </div>
                                                        </div>
                                                        <div className='row mt-3'>
                                                            <div className='col-12 d-flex align-items-center gap-2'>
                                                                <div className="icon-circle bg-white">
                                                                    <FaLocationDot className="text-secondary" />
                                                                </div>
                                                                <div>
                                                                    <p className="mb-0 f-small">{supplierDetail?.address + " " + supplierDetail?.city}</p>
                                                                    <p className="mb-0 f-small">{supplierDetail?.state + " " + supplierDetail?.pincode}</p>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    {(supplierDetail?.gst_number || supplierDetail?.designation || supplierDetail?.total_experience) ?
                                                        (<div className='row mt-2'>
                                                            <h5>Supplier Details</h5>
                                                            <p className="col-6 m-0 f-small text-secondary">
                                                                {supplierDetail?.gst_number ? `GST : ${supplierDetail?.gst_number}` : ""}
                                                            </p>
                                                            <p className="col-6 m-0 f-small text-secondary">
                                                                {supplierDetail?.designation ? `Designation : ${supplierDetail?.designation}` : ""}
                                                            </p>
                                                            <p className="col-6 m-0 f-small text-secondary">
                                                                {supplierDetail?.total_experience ? `Total Experience : ${supplierDetail?.total_experience}` : ""}
                                                            </p>
                                                            <p className="col-12 m-0 f-small text-secondary">
                                                                {supplierDetail?.additional_info ? `Other Details : ${supplierDetail?.additional_info}` : ""}
                                                            </p>
                                                        </div>) : ""}
                                                    <div className=''>
                                                        <h5>About</h5>
                                                        <p className=" f-small text-secondary  col-md-10">
                                                            {supplierDetail?.remark}
                                                        </p>
                                                    </div>
                                                    <div className=''>
                                                        <h5>Key Points</h5>
                                                        <p className=" f-small text-secondary  col-md-10">
                                                            <ul>
                                                                {(() => {
                                                                    try {
                                                                        const keyPoints = JSON.parse(supplierDetail?.key_points || '[]');
                                                                        return keyPoints.map((item, index) => <li key={index}>{item}</li>);
                                                                    } catch (error) {
                                                                        console.error("Invalid JSON in supplierDetail.key_points", error);
                                                                        return null;
                                                                    }
                                                                })()}
                                                            </ul>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className='row align-items-end'>
                                                    {supplierDetail.brochure &&
                                                        <div className="hero-block-two-body-right">
                                                            <button className="smp-round-btn ro-btn-theme f-small">
                                                                <a className='text-white' href={`https://msmesupplier.s3.ap-south-1.amazonaws.com/${supplierDetail?.brochure}`}> Download Broucher</a>
                                                            </button>
                                                        </div>
                                                    }
                                                    <div className="hero-block-two-body-right">
                                                        <button className="smp-round-btn ro-btn-theme f-small" onClick={() => { setModalShow(true) }}>
                                                            Get Enquiry
                                                        </button>
                                                    </div>

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="common-section pt-4">
                                <div className="container">
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="mb-4">
                                                <h4 className="">Supplier's Machinery & Equipments</h4>
                                            </div>
                                            <SupplierProductCards isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} setPage={setPage} page={page} />
                                        </div>
                                        <div className="col-md-4 ps-5">
                                            <div className="hero-block-sidebar-card bg-gray">
                                                <h4 className="mb-4 pb-3 border-bottom">Bank Information</h4>
                                                <div className="item-four m-0 mb-4">
                                                    <div className="icon-circle">
                                                        <BsPersonStanding className="text-secondary" />
                                                    </div>
                                                    <div className="item-four-body">
                                                        <h6 className="fw-bold l-height-1">Bank Person Name</h6>
                                                        <p className="mb-0 f-small">{supplierDetail?.bank_person_name ?? "N/A"}</p>
                                                    </div>
                                                </div>
                                                <div className="item-four m-0 mb-4">
                                                    <div className="icon-circle">
                                                        <AiFillTags className="text-secondary" />
                                                    </div>
                                                    <div className="item-four-body">
                                                        <h6 className="fw-bold l-height-1">Bank Name</h6>
                                                        <p className="mb-0 f-small">{supplierDetail?.bank_name ?? "N/A"}</p>
                                                    </div>
                                                </div>
                                                <div className="item-four m-0 mb-4">
                                                    <div className="icon-circle">
                                                        <BsFillEaselFill className="text-secondary" />
                                                    </div>
                                                    <div className="item-four-body">
                                                        <h6 className="fw-bold l-height-1">IFSC Code</h6>
                                                        <p className="mb-0 f-small">{supplierDetail?.bank_ifsc_code ?? "N/A"}</p>
                                                    </div>
                                                </div>
                                                <div className="item-four m-0 mb-4">
                                                    <div className="icon-circle">
                                                        <BsAwardFill className="text-secondary" />
                                                    </div>
                                                    <div className="item-four-body">
                                                        <h6 className="fw-bold l-height-1">Branch Name</h6>
                                                        <p className="mb-0 f-small">{supplierDetail?.bank_branch_name ?? "N/A"}</p>
                                                    </div>
                                                </div>
                                                <div className="item-four m-0 mb-4">
                                                    <div className="icon-circle">
                                                        <BsFillJournalBookmarkFill className="text-secondary" />
                                                    </div>
                                                    <div className="item-four-body">
                                                        <h6 className="fw-bold l-height-1">Bank Account Number</h6>
                                                        <p className="mb-0 f-small">{supplierDetail?.bank_account_number ?? "N/A"}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div></>)

                    }



                    <CmLeadModal
                        isModalOpen={modalShow}
                        setIsModalOpen={setModalShow}
                        leadtype={"CM YUVA SUPPLIER"}
                    />
                </main>

                <Footer />
            </>
        )


    );
}